<ng-container *ngIf="!env.USE_TAILWIND">
    <div class="progress-wrapper">
        <ridango-page-content-wrapper>
            <ridango-progress-v2 [steps]="steps$ | async" [activeStep]="activeStep$ | async"></ridango-progress-v2>
        </ridango-page-content-wrapper>
    </div>
    <!-- TODO: investigate those wrappers -->

    <div class="block--content block" id="main-content">
        <div class="block--wrap block">
            <rwidget-alert></rwidget-alert>
            <ridango-page-content-wrapper *ngIf="allowRegister">
                <!-- TODO: should check still the requirement of 'ticket' wrapper (or rename it to smth more understandable) -->
                <div class="ticket" *ngIf="(activeStep$ | async) === 1">
                    <rwidget-register-aside></rwidget-register-aside>
                    <div class="block__right-side-panel">
                        <rwidget-signup-form
                            [captchaToggleAllowed]="captchaToggleAllowed"
                            [options]="registerOptions"
                            (registerEvent)="register($event)">
                        </rwidget-signup-form>
                    </div>
                </div>

                <rwidget-email-sent
                    *ngIf="(activeStep$ | async) === 2"
                    [email]="email"
                    [description]="'REGISTRATION_VALIDATION_MAIL_DESCRIPTION'"></rwidget-email-sent>
            </ridango-page-content-wrapper>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="env.USE_TAILWIND">
    <div
        class="progress-wrapper bg-gray-50 py-4"
        *ngIf="env.REGISTRATION?.ENABLE_REGISTRATION_STEPS && (activeStep$ | async) <= 2">
        <div class="max-content">
            <ridango-progress-v2 [steps]="steps$ | async" [activeStep]="activeStep$ | async"></ridango-progress-v2>
        </div>
    </div>
    <rwidget-alert></rwidget-alert>
    <div id="main-content" *ngIf="allowRegister">
        <div class="relative flex items-center justify-center bg-white py-[22px]" *ngIf="env.IS_MOBILE_APP">
            <ridango-ui-back-button
                class="absolute left-4 top-1/2 -translate-y-1/2 [&>button]:flex"
                [bottomMargin]="false"
                (click)="handleBackClicked()"
                classIcon="w-7 h-7"></ridango-ui-back-button>
            <h1 class="text-center text-base font-bold leading-5">
                {{ 'CREATE_ACCOUNT' | translate }}
            </h1>
        </div>
        <ng-container *ngIf="(activeStep$ | async) === 1">
            <div class="overflow-hidden">
                <div class="max-content max-content--secondary md:grid md:min-h-[73vh] md:grid-cols-2">
                    <aside
                        class="pil-light-dark:justify-start relative hidden min-h-[20vh] items-center justify-center py-5 before:absolute before:-left-[100vw] before:-right-[100vw] before:bottom-0 before:top-0 before:-z-10 before:bg-[#F8F8F8] before:content-[''] dark:before:bg-contrast-black md:flex md:h-auto md:pr-8 md:before:right-0">
                        <rwidget-register-aside class="md:w-full lg:max-w-[26rem]"></rwidget-register-aside>

                        <div
                            class="flex h-full items-center md:invisible md:w-auto lg:visible lg:w-[56%]"
                            *ngIf="env.THEME_NAME === themeFeature.PILET">
                            <img
                                class="absolute -right-[2rem] z-10 h-[62vh] dark:filter-yellow"
                                alt=""
                                src="./assets/img/ridango-logo-shape.svg" />
                        </div>
                    </aside>

                    <section
                        class="pil-light-dark:lg:pl-20 relative flex min-h-[60vh] max-w-2xl items-center justify-items-center bg-white py-5 before:absolute before:-left-[100vw] before:-right-[100vw] before:bottom-0 before:top-0 before:-z-10 before:bg-white before:content-[''] md:h-auto md:pl-8 md:before:left-0">
                        <rwidget-signup-form
                            class="w-full"
                            [captchaToggleAllowed]="captchaToggleAllowed"
                            [options]="registerOptions"
                            (registerEvent)="register($event)">
                        </rwidget-signup-form>
                    </section>
                </div>
            </div>
        </ng-container>
        <rwidget-email-sent
            *ngIf="(activeStep$ | async) === 2"
            [email]="email"
            [description]="'REGISTRATION_VALIDATION_MAIL_DESCRIPTION'"></rwidget-email-sent>
    </div>
</ng-container>
